export const removeNonNumericCharacters = (value) => {
  if (!value) {
    return value
  }
  return value?.replace(/\D+/g, '')
}

export const matchEmail = (email1, email2) => email1 && email2 && email1?.toLowerCase() === email2?.toLowerCase()
